import { render } from "./CtaCard.vue?vue&type=template&id=2746d7be"
import script from "./CtaCard.vue?vue&type=script&lang=js"
export * from "./CtaCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__